app.service("OptionProductService", ['$rootScope', function ($rootScope) {

    const service = this;

    const siteHelper = $rootScope.site_helper;

    const modelConstructor = $rootScope.model_constructor;

    const ModelChoice = modelConstructor.ModelChoice;

    /*
    Options that the user sees may appear very similar but they initiated in 4 very different ways

    1) Initiated by the server - complex.

    These are very common options in the site. A product such as a door
    when retrieved from the API will come with an object called 'options' each key is a numerical id (e.g. 1234, or 4567),
    while each value is the equivalent of an 'option_term' choice.
    What makes these options complex is that you have to sort through every 'option_term' choice you are given and develop a tree
    structure by looking through each items parents to first of all establish what they top layer (first) 'option_term' group is,
    then depending on what a user selects for that layer the contents and values of the next layer may change.

    Example (not real values):  A Zurfiz Inset door might have choices for a first 'edge_option' 'option_term' of 'matching',
    'plywood' and 'glass'. The for a second 'inset_handle' 'option_term' group it may have choices of 'standard', 'curved_138' and 'curved_234'.
    In this instance we would have received 3 'edge_option' option_term objects fom the server. However we would receive
    9 'inset_handle' choices. We have to determine that once say the user has selected a 'matching' option_term choice, that we are using
    the server 'option_term' choices who have a 'parent' id that matches the numerical id of 'matching' 'edge_option'

    In most cases the amount of 'option_term' groups and the amount of choices in each 'option_term' groups (and the names the user sees for each choice)
    won't change depending on what the users picks but this is not a fixed rule. There have been in the past (and likely still
    are. I just can't recall any examples at the time of writing) where there can be big changes here depending on what the user picks .

    One final complication from these 'complex' options is that the server doesn't provide us with everything we need to show. Primarily the issue
    is that we will be told about this list of complex options and then on top of the sorting process described above we also need to determine
    which images need to be shown for each choice.
    This is quite tricky to do in what is intended to be a 100% dynamic system. The numerical ids provided by the server can not be used by us because
    what we would consider to be single 'option_term' choice may easily have 20+ numerical ids associated with it (if say it  was a 3rd layer option).
    We instead use the 'narrative' value provided by the server. In OptionTermService where there are choices for each model variation you will sometimes see
    a 'narratives' array underneath a choice. This is what we use to match our hardcoded description of an option_term choice against a dynamic
    server choice.
    Because the server provides so many possible options there are instances when the 'narrative' they provide can not be relied upon to 100% match the same
    structure we use here. So when comparing against narratives we sometimes need to do a few different checks:
    Firstly: when building a list of our own option_term instances to check we pass in a variationIDs object. Anything that doesn't match the variation is excluded.
    This will typically help us to exclude option_term variations that expect us to be using a specific style at the time.
    Secondly: we check against multiple narratives from an option_term group we have built up from the server to make sure they all match.



    2) Initiated by server. Simple.

    These are much more simple to understand. Like with the 'complex' options the server tells us about them in an 'options' object that comes
    with an api product, But instead of a numerical id we get a string id which we are able to reuse to match the sites 'option' model choice ids

    Example: Bedroom wardrobes may come with an option object with keys 'internal_left' and 'internal_right'. We just look for any such keys in our
    model choices and just const the server 'option_term'  work along side the site equivalent



    3) Initiated by site. Single product.

    These option_terms will often be required by the server when adding a product to the cart, but unlike the options above, the server
    does not tell us that we need to show them. Instead we need to identify that certain products such as doors or panels
    will either always require these options, or if certain specifications such as a specific style have been selected, then we need
    to show this option_term to the user.

    e.g. In ProductDoorService a lot of door model variations will have a function 'getLocalOptionTermConfig'. This tells us that it is likely
    that when this product is shown that any option terms matching the optionIDs underneath will need to be displayed

    There will however be some circumstances when such an option_term is still intentionally not displayed. e.g. If the OptionTermService
    tells us that this variation is not available for the currently selected style then it won't be. Or in some circumstances such as with
    'midrail' The option will be available in the background but will only become visible to the user once has decided they want some
    specific input requirements (such as a door height >= 1700mm)

    Most option_terms the user sees will be able to rely exclusively on the Model/Choice structure that is widely used throughout this site,
    however there are a few instances where the option will also require the user to enter a value in an input field. And there are quite a
    few option_terms in the site (mainly with Bella Panels and Sloping Doors) where there are no 'Choices' whatsoever, instead the option_term
    relies on the user entering values in to input fields, checkboxes etc.



    4) Initiated by site. Multiple products.

    Before a user purchases Solution cabinet they will be asked to pick  from a selection of option_terms such as 'edge_option' or
    'clicbox_colour', then any cabinets that they add after this will come with the option_term values that they have selected.

    The 'applyModelVariation' function in the model of this OptionService class is able to quite easily determine
    which options should appear depending on which solution they are browsing or which style they have selected etc.

    Standard 'cabinets' behave similar to solution cabinets  simpler because we know there is always only 1 option needed
    'clicbox_colour'


    *** One more thing ***

    One extra complication that comes with options for products is that in a few rare instances (such as Open Frame frames), the option_terms provided
    to us with complex server options are intended to have differently depending on the height the user enters for their frame.

    because of this we have to factor in circumstances where  to repeat the entire process for a 'smallProduct'
    and a 'largeProduct' rather than just a 'product'

    * */

    const OptionProductModel = function () {
        this.server_option_terms = {};
        this.term_models = {};
        this.term_model_list = [];
        this.option_product_variation_id = "";
        this.known_state = "";
    }

    const optionProductVariations = {};


    this.createOptionProductModel = function (baseProduct, sizedProduct, variationIDs) {

        variationIDs = getValidVariationIDs(variationIDs);

        sizedProduct.option_product_model = new OptionProductModel();
        const optionProductModel = sizedProduct.option_product_model;

        sizedProduct.option_product_model.server_option_terms = sizedProduct.options ? sizedProduct.options : {};

        optionProductModel.option_product_variation_id = service.createOptionProductVariationID(variationIDs);

        const serverOptionTerms = siteHelper.simpleCloneObject(optionProductModel.server_option_terms);

        let referenceOptionProductModel;

        function requireReferenceOptionProductModel() {

            const optionProductVariationID = service.createOptionProductVariationID(variationIDs);
            referenceOptionProductModel = optionProductVariations[optionProductVariationID];
            if (referenceOptionProductModel) {
                return;
            }

            referenceOptionProductModel = new OptionProductModel();
            referenceOptionProductModel.option_product_variation_id = optionProductVariationID;

            const optionsIDs = $rootScope.service.option_term.option_ids;

            const optionTermModels = {};
            const optionTermModelList = [];

            for (let i = 0; i < optionsIDs.length; i++) {
                let optionTermModel = null;
                const optionID = optionsIDs[i];
                variationIDs.option_id = optionID;
                optionTermModel = $rootScope.factory.option_term.getModel(variationIDs);
                if (optionTermModel.disabled) {
                    continue
                }
                optionTermModels[optionID] = optionTermModel;
                optionTermModelList.push(optionTermModel);
            }

            delete variationIDs.option_id;

            referenceOptionProductModel.term_models = optionTermModels;
            referenceOptionProductModel.term_model_list = optionTermModelList;
        }

        function determineLocalOptionTermList() {
            const config = baseProduct.local_option_term_config;

            const modelList = [];
            for (let i = 0; i < config.length; i++) {
                const termConfig = config[i];

                const referenceOptionTermModel = referenceOptionProductModel.term_models[termConfig.option_id];
                if (!referenceOptionTermModel || referenceOptionTermModel.unavailable) {
                    continue
                }

                variationIDs.option_id = termConfig.option_id;
                const optionTermModel = $rootScope.factory.option_term.clonedModel(variationIDs);
                if (optionTermModel.unavailable) {
                    continue;
                }
                for (let key in termConfig) {
                    optionTermModel[key] = termConfig[key];
                }
                modelList.push(optionTermModel);
            }

            delete variationIDs.option_id;

            return modelList;
        }

        function determineSimpleServerOptionTermList() {
            let optionID, serverOptionTerm;

            const modelList = [];

            for (optionID in serverOptionTerms) { //e.g. Bedroom Solution internals will come with an optionID 'internal'
                serverOptionTerm = serverOptionTerms[optionID]


                const referenceOptionTermModel = referenceOptionProductModel.term_models[optionID];
                if (!referenceOptionTermModel || referenceOptionTermModel.unavailable) {
                    continue
                }

                variationIDs.option_id = optionID;
                variationIDs.source_id = "product";
                const optionTermModel = $rootScope.factory.option_term.clonedModel(variationIDs);

                if (optionTermModel.unavailable) {
                    continue;
                }
                const choiceOrder = [];
                const choices = {};
                for (let i = 0; i < optionTermModel.choice_order.length; i++) {
                    const choiceID = optionTermModel.choice_order[i];
                    if (serverOptionTerm.items && serverOptionTerm.items[choiceID]) {
                        choiceOrder.push(choiceID);
                        choices[choiceID] = optionTermModel.choices[choiceID];
                    }
                }

                for (let choiceID in serverOptionTerm.items) {
                    if (!choices[choiceID]) {
                        const serverChoice = serverOptionTerm.items[choiceID];
                        const choice = new ModelChoice({
                            id: choiceID,
                            name: serverChoice.name ? serverChoice.name : choiceID
                        })
                        choiceOrder.push(choiceID);
                        choices[choiceID] = choice;
                    }

                }
                optionTermModel.choice_order = choiceOrder;
                optionTermModel.choices = choices;

                if (serverOptionTerm.default && choices[serverOptionTerm.default]) {
                    optionTermModel.default_choice_id = serverOptionTerm.default;
                }

                let sortIndex = Number.MAX_SAFE_INTEGER;
                if (serverOptionTerm.hasOwnProperty('sort_index')) {
                    sortIndex = serverOptionTerm.sort_index
                } else if (optionTermModel.hasOwnProperty('sort_index')) {
                    sortIndex = optionTermModel.sort_index
                }

                optionTermModel.is_server_option_term = true;
                optionTermModel.required = !!optionTermModel.required || !!serverOptionTerm.required;
                optionTermModel.sort_index = sortIndex;
                optionTermModel.serverOptionTerm = serverOptionTerm;
                optionTermModel.hidden = serverOptionTerm.hidden || serverOptionTerm.disabled;

                modelList.push(optionTermModel);

                delete serverOptionTerms[optionID];
            }
            delete variationIDs.option_id;
            delete variationIDs.source_id;

            modelList.sort(function (a, b) {
                if (a.sort_index < b.sort_index) {
                    return -1;
                }
                if (a.sort_index > b.sort_index) {
                    return 1;
                }
                return 0;
            })
            return modelList;
        }


        function determineComplexOptionTermList(complexOptionTermChoices) {

            let complexOptionLayers, distinctOptionIDsByNarrative;

            function normalizeComplexOptionTermChoices() {
                /*
                This function was written to handle one particular server option scenario that no longer occurs.
                I believe there are currently no other examples of it happening right now but I am still keeping the
                function in the case of it happening again

                Typically the server option tree structure is identified by just looking or each items parent until
                you get to the top of the tree.

                Here there was a scenario that an items parent was intended to be invisible so the server did not
                provide a narrative.

                This function keeps looking further up the tree, every time it finds a parent without a narrative, it will
               keep going up until it finds one that can be displayed. it then replaces the original items parent with
               teh first 1 that can be displayed

                * */

                let complexOptionID, complexOptionTermChoice;

                const toBypass = {}
                let willBypass = false;
                for (complexOptionID in complexOptionTermChoices) {
                    complexOptionTermChoice = complexOptionTermChoices[complexOptionID];
                    if (!complexOptionTermChoice.narrative) {
                        complexOptionTermChoice.hidden = true;
                        toBypass[complexOptionID] = complexOptionTermChoice;
                        willBypass = true;
                    }
                }
                if (willBypass) {
                    for (complexOptionID in complexOptionTermChoices) {
                        complexOptionTermChoice = complexOptionTermChoices[complexOptionID];
                        let nextBypass = toBypass[complexOptionTermChoice.parent];
                        const bypassAppliedComplexOptionIDs = {};
                        while (nextBypass) {
                            const nextParent = toBypass[complexOptionTermChoice.parent];
                            complexOptionTermChoice.parent = nextParent.parent;
                            nextBypass = toBypass[nextParent.parent]
                            if (bypassAppliedComplexOptionIDs[nextParent.parent]) {
                                break;
                            }
                            bypassAppliedComplexOptionIDs[nextParent.parent] = true;
                        }

                    }
                }
            }

            function createComplexOptionLayers() {
                let complexOptionID, complexOptionTermChoice;

                //Anything added to the first layer will need to have a 'parent' of '0'
                let previousLayerItems = {0: {}};
                let currentLayerItems = {};

                complexOptionLayers = [];

                //repeatedly cycle through every item in the complexOptionTermChoices object, to see which items have a 'parent'
                //the same as any of the previous layers ids
                while (true) {
                    for (complexOptionID in complexOptionTermChoices) {
                        complexOptionTermChoice = complexOptionTermChoices[complexOptionID];

                        //If an items parent is in the previous layers ids, the item will be added to the current layer
                        if (previousLayerItems[complexOptionTermChoice.parent]) {
                            currentLayerItems[complexOptionID] = complexOptionTermChoice;
                            //We remove the items from our main object so that they don't get found again in the next while loop
                            delete complexOptionTermChoices[complexOptionID];
                        }
                    }

                    //If no items are found with parents matching any of the current layers ids then the gathering process is ocmplete
                    if (siteHelper.keyCount(currentLayerItems) === 0) {
                        break;
                    }

                    //We have identified every item relevant to this option_term layer. Add a new entry to the model
                    //with these items
                    complexOptionLayers.push({
                        complex_option_term_choices: currentLayerItems,
                        complex_option_term_choice_list: [],
                        narratives: {}
                    })

                    //reset previous and current so the next layer can be found
                    previousLayerItems = currentLayerItems;
                    currentLayerItems = {};
                }
            }

            function sortComplexOptionLayers() {

                let complexOptionID, complexOptionTermChoice;

                for (let i = 0; i < complexOptionLayers.length; i++) {
                    for (complexOptionID in complexOptionLayers[i].complex_option_term_choices) {
                        complexOptionTermChoice = complexOptionLayers[i].complex_option_term_choices[complexOptionID];
                        if (complexOptionTermChoice.hidden) {
                            delete complexOptionLayers[i].complex_option_term_choices[complexOptionID];
                        } else {
                            //Add narratives for each item so we can match this complexOptionTermChoice against a variation
                            //in the OptionTermService model
                            complexOptionLayers[i].narratives[complexOptionTermChoice.narrative] = true;
                            complexOptionLayers[i].complex_option_term_choice_list.push(complexOptionTermChoice);
                        }
                    }
                    complexOptionLayers[i].complex_option_term_choice_list.sort(function (a, b) {
                        if (a.id < b.id) {
                            return -1;
                        }
                        if (a.id > b.id) {
                            return 1;
                        }
                        return 0;
                    })
                }
            }

            function collectDistinctOptionIDsByNarrative() {

                const optionIdListsByNarrative = {}
                distinctOptionIDsByNarrative = {}
                for (let optionID in referenceOptionProductModel.term_models) {
                    const referenceOptionTermModel = referenceOptionProductModel.term_models[optionID];
                    if (referenceOptionTermModel.unavailable) {
                        continue;
                    }
                    if (referenceOptionTermModel.narratives) {
                        for (let narrative in referenceOptionTermModel.narratives) {
                            if (!optionIdListsByNarrative[narrative]) {
                                optionIdListsByNarrative[narrative] = []
                            }
                            optionIdListsByNarrative[narrative].push(optionID);
                        }
                    }
                }

                for (let narrative in optionIdListsByNarrative) {
                    const optionIDs = optionIdListsByNarrative[narrative];
                    if (optionIDs.length === 1) {
                        distinctOptionIDsByNarrative[narrative] = optionIDs[0];
                    }
                }
            }

            function createComplexTermModelList() {
                let i, j, choiceID;
                const modelList = [];
                for (i = 0; i < complexOptionLayers.length; i++) {
                    const complexOptionTermNarratives = complexOptionLayers[i].narratives;

                    let optionID = null;
                    const first = null;
                    for (let complexOptionTermNarrative in complexOptionTermNarratives) {
                        optionID = distinctOptionIDsByNarrative[complexOptionTermNarrative];
                        if (optionID) {
                            break
                        }
                    }

                    let optionTermModel = null;

                    if (optionID) {

                        variationIDs.option_id = optionID;
                        optionTermModel = $rootScope.factory.option_term.clonedModel(variationIDs);

                    }

                    if (!optionTermModel || optionTermModel.unavailable) {
                        console.warn("Complex choice does not exist. Contains: " + first);
                        continue;
                    }
                    
                    const choiceIDsByNarrative = {};
                    for (choiceID in optionTermModel.choices) {
                        const choice = optionTermModel.choices[choiceID];
                        if (choice.narratives) {
                            for (j = 0; j < choice.narratives.length; j++) {
                                choiceIDsByNarrative[choice.narratives[j]] = choiceID;
                            }
                        }
                    }

                    const sortedComplexOptionTermChoices = {};
                    for (let complexOptionID in complexOptionLayers[i].complex_option_term_choices) {
                        const complexOptionTermChoice = complexOptionLayers[i].complex_option_term_choices[complexOptionID];
                        choiceID = choiceIDsByNarrative[complexOptionTermChoice.narrative];
                        complexOptionTermChoice.choice_id = choiceIDsByNarrative[complexOptionTermChoice.narrative];
                        if (choiceID) {
                            const parentID = complexOptionTermChoice.parent ? parseInt(complexOptionTermChoice.parent) : 0;
                            if (!sortedComplexOptionTermChoices[choiceID]) {
                                sortedComplexOptionTermChoices[choiceID] = {}
                            }
                            sortedComplexOptionTermChoices[choiceID][parentID] = complexOptionTermChoice
                        } else {
                            console.warn("Complex choice not found: " + complexOptionTermChoice.narrative);
                        }
                    }

                    optionTermModel.is_server_option_term = true;
                    optionTermModel.is_complex_option_term = true;
                    optionTermModel.complex_option_term_choices = sortedComplexOptionTermChoices;
                    optionTermModel.required = true;

                    modelList.push(optionTermModel);
                }
                delete variationIDs.option_id;

                return modelList;
            }

            if (siteHelper.keyCount(complexOptionTermChoices) === 0) {
                return [];
            }

            normalizeComplexOptionTermChoices();
            createComplexOptionLayers();
            sortComplexOptionLayers();
            collectDistinctOptionIDsByNarrative();
            return createComplexTermModelList();
        }

        function applyOptionTermModels() {
            const optionTermModels = {};
            for (let i = 0; i < optionProductModel.term_model_list.length; i++) {
                const optionTermModel = optionProductModel.term_model_list[i];
                if (optionTermModel.applyInitState) {
                    optionTermModel.applyInitState(baseProduct);
                }
                optionTermModels[optionTermModel.option_id] = optionTermModel;
            }
            optionProductModel.term_models = optionTermModels;
        }

        requireReferenceOptionProductModel();

        const localOptionTermList = determineLocalOptionTermList();
        const simpleServerOptionTermList = determineSimpleServerOptionTermList();
        const complexOptionTermList = determineComplexOptionTermList(serverOptionTerms);


        optionProductModel.term_model_list = [].concat(complexOptionTermList, simpleServerOptionTermList, localOptionTermList);
        applyOptionTermModels();
    }

    function getValidVariationIDs(variationIDs) {
        const validIDs = {};
        const fromValidPointers = $rootScope.factory.option_term.validVariationPointers()
        for (let key in variationIDs) {
            if (!fromValidPointers.includes(key) || key === "option_id") {
                continue;
            }
            validIDs[key] = variationIDs[key];
        }
        return validIDs;
    }

    this.createOptionProductVariationID = function (variationIDs) {
        variationIDs = getValidVariationIDs(variationIDs);
        return siteHelper.createUniqueObjectString(variationIDs, "option_product");
    }

    function currentComplexOptionTermChoices(product, requireComplete) {
        const complexOptionTermChoices = [];
        let didComplete = true;
        const optionProductModel = product.getOptionProductModel();
        for (let i = 0; i < optionProductModel.term_model_list.length; i++) {
            const optionTermModel = optionProductModel.term_model_list[i];
            if (!optionTermModel.is_complex_option_term) {
                continue;
            }
            const complexChoice = optionTermModel.currentComplexOptionTermChoice(product);
            if (complexChoice) {
                complexOptionTermChoices.push(complexChoice);
            } else {
                didComplete = false;
                break
            }
        }
        if (requireComplete && !didComplete) {
            return [];
        }
        return complexOptionTermChoices;
    }

    this.currentComplexOption = function (product, requireComplete) {
        const complexOptionTermChoices = currentComplexOptionTermChoices(product, requireComplete);
        return complexOptionTermChoices.length > 0 ? complexOptionTermChoices[complexOptionTermChoices.length - 1] : {
            id: 0,
            surcharge: 0,
            fixed_cost: 0,
            narrative: ""
        };
    }

}]);